import React, { useState } from 'react';
import {
  View,
  StyleSheet,
  Platform,
  Text, StatusBar,
  Linking
} from 'react-native';

import { COLORS, SIZES, FONTS } from '../constants';
import { OutlineBtn, SolidBtn } from "../components"

export default function AuthorScreen() {


  return (
    <>
      <View style={styles.container}>

        <Text style={styles.infoText}>
          created by Adamo for {"\n"}🇵🇱 Defenders 💪🏻
        </Text>
        <OutlineBtn
          text="GitHub"
          icon="github"
          onPress={() => { Linking.openURL('https://github.com/pajlotapps') }}
        />

        <SolidBtn
          text="Buy me a Coffee ☕️"
          icon="coffee"
          onPress={() => { Linking.openURL('https://www.buymeacoffee.com/pajlotapps') }}
        />

      </View>
    </>
  )
}

const styles = StyleSheet.create({
  container: {
    padding: Platform.OS === "ios" ? 40 : StatusBar.currentHeight + 10,
    flex: 1,
    alignItems: 'center', 
    justifyContent: 'center',
    backgroundColor: COLORS.background,
    padding: SIZES.padding,
  },
  infoText: {
    color: COLORS.primary,
    fontWeight: 'bold',
    fontSize: 24,
    paddingTop: 0
  },
  titleText: {
    ...FONTS.title
  },
  subtitleText: {
    ...FONTS.subtitle
  },
})